var _style, _defs, _defs2, _g, _defs3, _path, _path2, _g2, _g3, _g4, _g5, _g6, _g7, _g8;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgGreenCsv(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 60 56.13",
    style: {
      enableBackground: "new 0 0 60 56.13"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0b{fill:#6FB7FF;}\n\t.st1{fill:#FFFFFF;}\n\t.st2{clip-path:url(#SVGID_00000034807083724974039070000012452956039807837322_);}\n\t.st3{fill:#CFD1D2;}\n\t.st4{fill:#1CA669;}\n")), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("circle", {
    id: "SVGID_1_",
    cx: 28.06,
    cy: 31.94,
    r: 24.19
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000106862907643519676250000001521810390864379823_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_1_",
    style: {
      overflow: "visible"
    }
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, _defs2 || (_defs2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("circle", {
    id: "SVGID_00000102529563030403170820000013204956069174019492_",
    cx: 28.06,
    cy: 28.06,
    r: 24.19
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000137827245848955290830000006685017017536622772_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000102529563030403170820000013204956069174019492_",
    style: {
      overflow: "visible"
    }
  }))), /*#__PURE__*/React.createElement("g", null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    className: "st0b",
    cx: 28.06,
    cy: 28.06,
    r: 24.19
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M28.06,3.87c13.36,0,24.19,10.83,24.19,24.19S41.43,52.26,28.06,52.26S3.87,41.43,3.87,28.06 S14.7,3.87,28.06,3.87 M28.06,0C12.59,0,0,12.59,0,28.06s12.59,28.06,28.06,28.06s28.06-12.59,28.06-28.06S43.54,0,28.06,0 L28.06,0z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, _defs3 || (_defs3 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("circle", {
    id: "SVGID_00000054268271432487086110000016502227298624776111_",
    cx: 28.06,
    cy: 28.06,
    r: 24.19
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000008141792083119635240000005927636888400493206_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000054268271432487086110000016502227298624776111_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000008141792083119635240000005927636888400493206_)"
    }
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0b",
    d: "M39.65,55.16H16.48c-0.55,0-1-0.45-1-1V15.52c0-0.55,0.45-1,1-1h23.16c0.55,0,1,0.45,1,1v38.65 C40.65,54.71,40.2,55.16,39.65,55.16z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M38.71,56.13H17.42c-1.6,0-2.9-1.3-2.9-2.9V16.45c0-1.6,1.3-2.9,2.9-2.9h21.29c1.6,0,2.9,1.3,2.9,2.9 v36.77C41.61,54.83,40.31,56.13,38.71,56.13z M17.42,15.48c-0.53,0-0.97,0.43-0.97,0.97v36.77c0,0.53,0.43,0.97,0.97,0.97 h21.29c0.53,0,0.97-0.43,0.97-0.97V16.45c0-0.53-0.43-0.97-0.97-0.97H17.42z"
  })))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    className: "st3",
    x1: 19.96,
    y1: 25.73,
    x2: 31.23,
    y2: 25.73
  }), /*#__PURE__*/React.createElement("rect", {
    x: 19.96,
    y: 24.76,
    className: "st1",
    width: 11.26,
    height: 1.94
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    className: "st3",
    x1: 19.96,
    y1: 31.53,
    x2: 35.1,
    y2: 31.53
  }), /*#__PURE__*/React.createElement("rect", {
    x: 19.96,
    y: 30.57,
    className: "st1",
    width: 15.13,
    height: 1.94
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    className: "st3",
    x1: 19.96,
    y1: 35.4,
    x2: 35.1,
    y2: 35.4
  }), /*#__PURE__*/React.createElement("rect", {
    x: 19.96,
    y: 34.44,
    className: "st1",
    width: 15.13,
    height: 1.94
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    className: "st3",
    x1: 19.96,
    y1: 43.15,
    x2: 33.16,
    y2: 43.15
  }), /*#__PURE__*/React.createElement("rect", {
    x: 19.96,
    y: 42.18,
    className: "st1",
    width: 13.2,
    height: 1.94
  }))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    className: "st3",
    x1: 19.96,
    y1: 39.27,
    x2: 31.23,
    y2: 39.27
  }), /*#__PURE__*/React.createElement("rect", {
    x: 19.96,
    y: 38.31,
    className: "st1",
    width: 11.26,
    height: 1.94
  }))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    className: "st1",
    x1: 23.55,
    y1: 30,
    x2: 23.55,
    y2: 50.11
  }), /*#__PURE__*/React.createElement("rect", {
    x: 22.58,
    y: 30,
    className: "st0b",
    width: 1.94,
    height: 20.11
  }))))), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    className: "st4",
    cx: 47.42,
    cy: 43.55,
    r: 12.5
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M47.42,34.84c4.8,0,8.71,3.91,8.71,8.71s-3.91,8.71-8.71,8.71c-4.8,0-8.71-3.91-8.71-8.71 S42.62,34.84,47.42,34.84 M47.42,30.97c-6.95,0-12.58,5.63-12.58,12.58s5.63,12.58,12.58,12.58S60,50.5,60,43.55 S54.37,30.97,47.42,30.97L47.42,30.97z"
  })), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "47.3,47.71 42.91,42.22 44.42,41.01 47.53,44.9 55.79,37.49 57.08,38.93  "
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGreenCsv);
export default __webpack_public_path__ + "static/media/green_csv.f5cfd3781d7e02fd380b47de023fc5aa.svg";
export { ForwardRef as ReactComponent };